<script lang="ts">
export default {
  props:{
      steps: {type:Number, required:false},
      currentStep: {type:Number, required:false}
  }
}
</script>

<template>
    <div class="step-container">
      <div 
        v-for="(step, index) in steps" 
        :key="index"
        class="step-bubble"
        :class="{ 'active': currentStep === (index+1) }">
      </div>
    </div>
  </template>
  
  <style>
  .step-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }
  
  .step-bubble {
    width: 10px;
    height: 10px;
    border-radius: 10px;
    background-color: gray;
    transition: all 0.3s;
  }
  
  .step-bubble.active {
    width: 22px;
    height: 10px;
    border-radius: 10px;
    background-color: var(--factstorylight);
  }
  </style>
  